/**
 * Vincent B682 (Eric 2026-02-XX) — Barre de recherche de transcription
 * extraite de VideoDetailPage.js. Petit composant utilitaire avec bouton
 * de clear + compteur de résultats.
 *
 * Vincent B935 v2 (Eric 2026-02-14 SPEC STRICK PROD) — Ajoute un mode
 * `compact` qui retire le wrapper `p-3 border-b` pour permettre l'inline
 * sur la même ligne que le sélecteur Transcription + case canonique.
 */
import { MagnifyingGlass, X } from "@phosphor-icons/react";

export default function TranscriptSearchBar({ value, onChange, resultCount, placeholder, compact = false }) {
  const inner = (
    <>
      <div className="relative">
        <MagnifyingGlass size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-zinc-400" />
        <input
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`w-full ${compact ? "h-7" : "h-8"} pl-8 pr-8 text-sm bg-zinc-50 border border-zinc-200 rounded-md focus:outline-none focus:ring-1 focus:ring-[#002FA7] focus:border-[#002FA7]`}
          data-testid="transcript-search"
        />
        {value && (
          <button
            onClick={() => onChange("")}
            className="absolute right-2 top-1/2 -translate-y-1/2 text-zinc-400 hover:text-zinc-600"
            data-testid="transcript-search-clear"
            aria-label="Clear search"
          >
            <X size={14} />
          </button>
        )}
      </div>
      {value && (
        <p className={`text-[11px] text-zinc-400 ${compact ? "mt-0.5" : "mt-1.5"}`} data-testid="transcript-search-count">
          {resultCount} resultat{resultCount !== 1 ? "s" : ""}
        </p>
      )}
    </>
  );
  if (compact) {
    // Inline (utilisé dans la ligne 1 du TranscriptPanel B935 v2).
    // Vincent B935 v3 (Eric 2026-02-14) — min-w réduit à 130px pour
    // tenir sur une seule ligne à 1440px sans wrap.
    return <div className="flex-1 min-w-[130px]" data-testid="transcript-search-compact">{inner}</div>;
  }
  return <div className="p-3 border-b border-zinc-100">{inner}</div>;
}
